import { inject, observer } from 'mobx-react';
import React, { useImperativeHandle, useMemo } from 'react';

import { AppContextType } from '@byted-cg/linkchat-plugin';

import classes from '../constants/classes';
import { prefixCls } from '../utils/style';
import { usePanel } from './hooks/usePanel';
import { IInputWrapperRef } from './InputWrapper';

export interface IPanelWrapperRef {
  toggle: (panel: false | string) => void;
  getCur: () => string;
}

type Panel = {
  name: string;
  panel: React.ReactElement;
};
interface PanelWrapperProps {
  appContext?: AppContextType;
  inputRef?: React.RefObject<IInputWrapperRef>;
  panels: Panel[];
}

const PCPanelWrapper = React.forwardRef<IPanelWrapperRef, PanelWrapperProps>(
  (props, ref) => {
    const { panels, appContext } = props;
    const [currentPanel, setCurrentPanel] = usePanel();
    useImperativeHandle(
      ref,
      (): IPanelWrapperRef => ({
        toggle: handleToggle,
        getCur: () => currentPanel,
      }),
    );
    const handleToggle = (panel: false | string) => {
      // Close the panel
      if (panel === false) {
        setCurrentPanel('');
        return;
      }
      if (panel === 'keyboard') {
        appContext?.$refs?.$input?.current?.focus();
        return;
      }
      setCurrentPanel(panel);
    };

    // //Calculate the panel that currently needs to be displayed
    // const curPanel = useMemo(() => {
    //   return panels.map(({ name }) => name === currentPanel)?.panel;
    // }, [currentPanel]);

    // Determine whether to display the panel
    const display = useMemo(() => {
      // Show custom panel if currently selected panel exists
      if (panels.some(({ name }) => name === currentPanel)) return 'block';
      // Other cases hide panel
      return 'none';
    }, [currentPanel, panels]);

    return (
      <div
        style={{
          display: display,
          overflow: 'auto',
        }}
        className={prefixCls(
          {
            [`${classes.prefix}PCPanelWrapper`]: true,
          },
          appContext?.query?.isPc,
        )}
      >
        {panels.map(({ name, panel }) =>
          React.cloneElement(panel, {
            style:
              name === currentPanel
                ? {}
                : {
                    display: 'none',
                  },
          }),
        )}
      </div>
    );
  },
);

export default inject(({ appContext }) => ({
  appContext,
}))(observer(PCPanelWrapper));
